import React from 'react'
import {
  Grid,
  Box,
  RadioGroup,
  FormControlLabel,
  Link,
} from '@material-ui/core'
import StyledRadio from '@src/routes/Configurators/utils/ConfiguratorCustomRadioButton'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import messages from '../../messages'
import { configContext } from '../../utils/StandardReducer'
import { Modification, TubeProduct } from '../../utils/enum'
import globalStyles from '@src/routes/Configurators/utils/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: 'white',
      padding: theme.spacing(2, 5, 4),
      marginBottom: theme.spacing(3),
    },
    headerInstruction: {
      fontSize: theme.typography.pxToRem(14),
    },
    label: {
      fontWeight: 'bold',
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(1),
    },
    radioLabel: {
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(0.5),
    },
    subHead: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightBold,
      margin: theme.spacing(2, 0),
    },
    bottom: {
      marginTop: theme.spacing(-6),
      marginBottom: theme.spacing(4),
    },
    specificationsWrapper: {
      '& span.MuiFormControlLabel-label': {
        fontSize: theme.typography.pxToRem(12),
      },
    },
    radio: {
      padding: theme.spacing(1),
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 'bold',
    },
    modificationPlace: {
      float: 'left',
    },
    modificationRightPlace: {
      float: 'right',
    },
    fieldLabel: {
      marginTop: theme.spacing(5),
      '& label': {
        fontWeight: 'bold',
        fontSize: theme.typography.pxToRem(14),
      },
      '& .MuiInput-root': {
        width: '75%',
        '& .MuiSelect-root': {
          height: 35,
          lineHeight: '25px',
        },
      },
    },
    add: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
    },
    topSpacing: {
      marginTop: theme.spacing(-2),
      marginBottom: theme.spacing(-12),
    },
    aminoLabel: {
      fontSize: theme.typography.pxToRem(14),
      marginLeft: theme.spacing(0),
    },
    radioAlign: {
      marginLeft: theme.spacing(1),
      fontSize: theme.typography.pxToRem(14),
    },
    headerNotice: {
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(1),
    },
    leftMargin: {
      marginLeft: theme.spacing(-5),
    },
    disableAdd: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      opacity: 0.5,
    },
    disableText: {
      opacity: 0.6,
      marginLeft: theme.spacing(3),
    },
    description: {
      marginLeft: theme.spacing(3),
    },
  }
})

const AminoAcid = (props) => {
  const classes = useStyles()
  const globalClasses = globalStyles()
  const { state, dispatch } = React.useContext(configContext)
  const { sessionData, currentOligoIndex } = state
  const modificationResponseData = props.modificationResponseData
  const modificationType = props.modificationType
  const productType = props.productType
  const firstArray: any[] = []
  const secondArray: any[] = []
  const [isLabelledAminoAcid, setIsLabelledAminoAcid] = React.useState<any>(
    sessionData[currentOligoIndex].isLabelledAminoAcid
  )

  const arrayDevision = () => {
    let modificationCategory: {
      category: { categoryName: string; modifications: any[] }[]
    }
    let firstCategory
    if (modificationType === Modification.LabeledAminoAcid) {
      modificationResponseData.modifications.forEach((modifications) => {
        if (modifications.modificationType === Modification.LabeledAminoAcid) {
          modificationCategory = modifications
          modificationCategory.category.forEach((category) => {
            if (category.categoryName === Modification.LabeledAminoAcid) {
              firstCategory = category
            }
          })
        }
      })
      const sorted = [...firstCategory.modifications].sort(
        (firstMod, lastMod) => {
          return 1 * firstMod.name.localeCompare(lastMod.name)
        }
      )
      sorted.forEach((modification, index) => {
        if (index <= 6) {
          firstArray.push(modification)
        } else {
          secondArray.push(modification)
        }
      })
    } else {
      modificationResponseData.modifications.forEach((modifications) => {
        if (modifications.modificationType === Modification.InternalMod) {
          modificationCategory = modifications
          modificationCategory.category.forEach((category) => {
            if (category.categoryName === Modification.InternalMod) {
              firstCategory = category
            }
          })
        }
      })
      firstCategory.modifications.forEach((modification, index) => {
        if (index % 2 === 0) {
          firstArray.push(modification)
        } else {
          secondArray.push(modification)
        }
      })
    }
    return ''
  }

  const aquaInternalModChange = (event, aquaInternal) => {
    if (productType === TubeProduct.Aqua) {
      if (!isLabelledAminoAcid) {
        return false
      } else {
        dispatch({ type: 'SET_ERROR_ICON', data: false })
        dispatch({ type: 'FOCUS_ON_SEQUENCEBOX', data: true })
        return dispatch({
          type: 'UPDATE_AQUA_INTERNAL_MOD',
          data: aquaInternal,
        })
      }
    }
  }

  const aminoModificationList = (array) => {
    const AminoModifications: any[] = []

    array.forEach((modification) => {
      AminoModifications.push(
        <Grid container direction="row" className={classes.aminoLabel}>
          <Grid>
            <Link
              component="button"
              className={isLabelledAminoAcid ? classes.add : classes.disableAdd}
              onClick={(e) => aquaInternalModChange(e, modification.value)}
            >
              <FormattedMessage {...messages.CONF_ADD_BUTTON} />
            </Link>
          </Grid>
          <Grid
            className={
              isLabelledAminoAcid ? classes.description : classes.disableText
            }
          >
            {messages[modification.displayName]?.defaultMessage ||
              modification.displayName}
          </Grid>
        </Grid>
      )
    })
    return AminoModifications
  }

  const makeDisable = (event) => {
    const { value } = event.target
    const isTrueSet = value === 'true'
    setIsLabelledAminoAcid(isTrueSet)

    sessionData[currentOligoIndex].isLabelledAminoAcid = isTrueSet
    state.errorData.isLabelledAminoAcid = isTrueSet
    dispatch({
      type: 'UPDATE_ERROR_DATA',
      data: { ...state.errorData },
    })
    dispatch({
      type: 'UPDATE_INPUT',
      data: [...state.sessionData],
    })
    dispatch({ type: 'IS_LABEL_AMINO_ACID_ERROR', data: true })
  }

  React.useEffect(() => {
    if (state.isPageLoad === 2) {
      setIsLabelledAminoAcid(sessionData[currentOligoIndex].isLabelledAminoAcid)
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.isPageLoad])

  const displayHeader = () => {
    if (modificationType === 'labeledAminoAcids') {
      return (
        <Grid container alignItems="flex-end" className={classes.bottom}>
          <Grid item xs={10}>
            <div className={classes.label}>
              <FormattedMessage {...messages.CONF_AMINO_ACID_RADIO_LABEL} />
            </div>
            <div className={classes.label}>
              <RadioGroup
                aria-label="aminoAcid"
                name="isLabelledAminoAcid"
                value={isLabelledAminoAcid.toString()}
                className={classes.radioAlign}
                onChange={makeDisable}
              >
                <FormControlLabel
                  control={
                    <StyledRadio
                      isConfiguratorsRedesign="true"
                      className={classes.radio}
                    />
                  }
                  classes={{ label: classes.radioLabel }}
                  value="false"
                  label={
                    <FormattedMessage
                      {...messages.CONF_AMINO_ACID_MODIFICATION_NO}
                    />
                  }
                  defaultChecked
                />
                <FormControlLabel
                  control={
                    <StyledRadio
                      isConfiguratorsRedesign="true"
                      className={classes.radio}
                    />
                  }
                  classes={{ label: classes.radioLabel }}
                  value="true"
                  label={
                    <FormattedMessage
                      {...messages.CONF_AMINO_ACID_MODIFICATION_YES}
                    />
                  }
                />
              </RadioGroup>
            </div>
          </Grid>
        </Grid>
      )
    } else {
      return (
        <Grid container alignItems="flex-end" className={classes.bottom}>
          <Grid item xs={12}>
            <div
              className={clsx(
                classes.headerInstruction,
                globalClasses.globalHelpTextColor
              )}
            >
              <FormattedMessage
                {...messages.CONF_AQUA_INTERNAL_MODIFICATION_INSTRUCTION}
              />
            </div>
            <div
              className={clsx(
                classes.headerNotice,
                globalClasses.globalHelpTextColor
              )}
            >
              <strong>
                <FormattedMessage {...messages.CONF_NOTE} />
              </strong>
              <FormattedMessage
                {...messages.CONF_AQUA_INTERNAL_MODIFICATION_NOTE}
              />
            </div>
          </Grid>
        </Grid>
      )
    }
  }
  return (
    <div>
      <div className={classes.contentWrapper}>
        <Box className={classes.leftMargin}>
          {displayHeader()}
          {arrayDevision()}
          <Grid container direction="row" className={classes.topSpacing}>
            <Grid item sm={6}>
              {aminoModificationList(firstArray)}
            </Grid>
            <Grid item sm={6}>
              {aminoModificationList(secondArray)}
            </Grid>
          </Grid>
        </Box>
      </div>
    </div>
  )
}

export default AminoAcid
